<template>
    <v-menu
        :content-class="'file-tags-menu-container --rating'"
        :nudge-bottom="8"
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-tippy
                :content="currentFile.type == 'image' ? 'Rate media asset' : 'Rate Candidate'"
                v-bind="attrs" v-on="on" :disabled="!canAssignTagToAsset || !image">
                <v-icon class="material-icons">star_rate</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                v-for="ratingTag in tags.rating"
                :key="ratingTag.value"
                :class="{ '--selected': fileHasTag(currentFile, 'rating', ratingTag.value) }"
                class="stars-icons-container"
                @click="addTag(currentFile, 'rating', ratingTag.value)"
            >
                <v-list-item-title v-if="ratingTag.value == 'none'">{{ ratingTag.label }}</v-list-item-title>
                <i v-for="index in ratingTag.value" v-else :key="index" class="material-icons">star_rate</i>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile', 'tags']),
        ...mapGetters('Projects', ['isCurrentFileShared']),
        ...mapGetters('User', ['isGuest']),
    },
    methods: {
        // TODO move to store
        fileHasTag(file, tagName, value) {
            if (file.tags) return file.tags.find(tag => tag.name == tagName && tag.pivot.value == value);
            else return false;
        },

        // TODO move to store
        async addTag(file, tag_name, tag_value) {
            let selectedFiles = [file];

            if (tag_name == "rating") {
                let sameTagOnAll = selectedFiles
                    .map(e => {
                        if (e.tags.find(tag => tag.name == tag_name)) return e.tags.find(tag => tag.name == tag_name).pivot.value;
                    })
                    .every(value => tag_value == value);
                if (sameTagOnAll) {
                    await this.$store.dispatch("Projects/removeTag", {
                        file_ids: selectedFiles.map(e => e.id),
                        tag_name,
                        tag_value,
                    });

                    // NOTE: can be implemented in back-end to auto switch to none
                    await this.$store.dispatch("Projects/addTag", {
                        file_ids: selectedFiles.map(e => e.id),
                        tag_name,
                        tag_value: "none",
                    });

                    await this.$store.dispatch("Projects/refreshProjectTree");
                    return;
                }
            }

            if (tag_name == "color") {
                let sameTagOnAll = selectedFiles
                    .map(e => e.tags.filter(tag => tag.name == "color").map(tag => tag.pivot.value))
                    .every(tag => tag.includes(tag_value));

                if (sameTagOnAll) {
                    await this.$store.dispatch("Projects/removeTag", {
                        file_ids: selectedFiles.map(e => e.id),
                        tag_name,
                        tag_value,
                    });

                    await this.$store.dispatch("Projects/refreshProjectTree");
                    return;
                }
            }

            await this.$store.dispatch("Projects/addTag", {
                file_ids: selectedFiles.map(e => e.id),
                tag_name,
                tag_value,
            });

            await this.$store.dispatch("Projects/refreshProjectTree");
        },
    }
}
</script>